export default function translate(i18n, propriete) {
  if (['bonExpeditionCreate.PoidsParColis', 'poidsParColis'].includes(propriete)) {
    return i18n.t('popupChangerEtatExpedition.poidsParColis');
  }
  if (['bonExpeditionCreate.DateBonExpedition', 'dateBonExpedition'].includes(propriete)) {
    return i18n.t('popupChangerEtatExpedition.dateExpedition');
  }
  if (['bonExpeditionCreate.NombreElementColis', 'nombreElementColis'].includes(propriete)) {
    return i18n.t('popupChangerEtatExpedition.nombreElementColis');
  }
  if (['bonExpedition.adresseExpedition.ville', 'adresseExpedition.Ville'].includes(propriete)) {
    return i18n.t('popupChangerEtatExpedition.errorFeild.adresseExpeditionVille');
  }
  if (['bonExpedition.adresseExpedition.intitule', 'adresseExpedition.Intitule'].includes(propriete)) {
    return i18n.t('popupChangerEtatExpedition.errorFeild.adresseExpeditionIntitule');
  }
  if (['bonExpedition.adresseExpediteur.ville', 'adresseExpediteur.Ville'].includes(propriete)) {
    return i18n.t('popupChangerEtatExpedition.errorFeild.adresseExpediteurVille');
  }
  if (['bonExpedition.adresseExpediteur.intitule', 'adresseExpediteur.Intitule'].includes(propriete)) {
    return i18n.t('popupChangerEtatExpedition.errorFeild.adresseExpediteurIntitule');
  }
  if (propriete === 'bonExpeditionCreate.AdresseExpedition') {
    return i18n.t('popupChangerEtatExpedition.adresseExpedition');
  }
  if (propriete === 'bonExpeditionCreate.AdresseExpediteur') {
    return i18n.t('popupChangerEtatExpedition.adresseExpediteur');
  }
  if (propriete === 'bonExpeditionCreate.InstructionDeLivraison') {
    return i18n.t('popupChangerEtatExpedition.instructionDeLivraison');
  }
  if (propriete === 'bonExpeditionCreate.ContactDestinataireId') {
    return i18n.t('popupChangerEtatExpedition.contactDestination');
  }
  if (propriete === 'bonExpeditionCreate.ContactExpediteurId') {
    return i18n.t('popupChangerEtatExpedition.contactExpediteur');
  }
  if (propriete === 'bonExpedition.adresseExpedition.codePostal') {
    return i18n.t('popupChangerEtatExpedition.errorFeild.adresseExpeditionCodePostal');
  }
  if (propriete === 'bonExpedition.adresseExpediteur.codePostal') {
    return i18n.t('popupChangerEtatExpedition.errorFeild.adresseExpediteurCodePostal');
  }
  return propriete;
}
